<template>
  <div>
    <van-list v-model="isLoading" :finished="isFinished" :finished-text="!list || list.length > 0 ? '没有更多了' : ''"
      @load="fetchData" class="users-list">
      <dl class="users-list" v-if="!isInit && (list && list.length>0)">
        <dt class="users-title">
          <span class="title">喜欢我的人</span>
        </dt>
        <dd class="users-item" v-for="(item, index) in list" :key="index" @click="jump(item)">
          <div class="head-box">
            <div class="img-box">
              <img v-lazy="item.headPicUrl" alt="" class="img" />
            </div>
          </div>
          <div class="infomation">
            <p class="name-box"><span class="name">{{item.nickName}}</span></p>
            <p class="sentence">
              现居{{`${parseInt(item.cityId) === 900000 ? (item.country + ' ' + item.state) : areaData['city_list'][item.cityId]}`}}
              {{item.age}}岁 {{item.high}}cm {{educationMap[item.education]}}
              {{item.ifStudent ? '在读' : item.job}}</p>
          </div>
        </dd>
      </dl>
      <dl class="users-list" v-if="!isInit && (!list || list.length === 0)">
        <dt class="users-title">
        </dt>
        <dd>
          <p class="no-message-tips">当前暂无喜欢我的人</p>
          <img src="~@/assets/img/no-search-result.png" alt="" class="no-message-img" />
        </dd>
      </dl>
    </van-list>
    <van-dialog v-model="isShowDialog" confirmButtonText="我知道了" @confirm="confirm" @closed="closed">
      <div id="user-message-dialog">
        <p class="tips">对于喜欢你的人，你只须要回点ta一个喜欢，即可免费获得对方的微信号</p>
        <div class="not-show-again" @click="checkKnown">
          <span class="check-box" :class="{'isChecked': notShowAgain}"><img v-if="notShowAgain" src="~@/assets/img/tick.png" /></span>
          <span class="known">已知悉，不在显示该提示</span>
        </div>
      </div>
    </van-dialog>

    <banModal v-model="showModal" />

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Storage from '@/utils/Storage'
import banModal from './component/banModal'

export default {
  name: 'LikeMe',
  components: {
    banModal
  },
  data () {
    return {
      isLoading: false,
      isFinished: false,
      currentPage: 1,
      pageSize: 20,
      isInit: true,
      list: [],
      currentId: '',
      currentItem: {},
      isShowDialog: false,
      notShowAgain: false,
      showModal: false
    }
  },
  computed: {
    ...mapState({
      educationMap: 'educationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {
    fetchData () {
      this.$root.openLoading()
      this.isLoading = true
      this.$http('/api/member/action/list', {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        actionType: 23
      }, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000' && res.data) {
          const data = res.data
          if (this.currentPage === 1) {
            this.list = data.data
          } else {
            this.list = [...this.list, ...data.data]
          }
          try {
            if (this.pageSize > data.data.length || !this.userId) {
              this.isFinished = true
            }
          } catch (err) {
            this.isFinished = true
          }
          this.currentPage++
        } else {
          this.isFinished = true
          this.$toast(res.msg)
        }
      }, err => {
        this.isFinished = true
        this.isLoading = false
        this.$toast(err)
      }).finally(() => {
        this.isInit = false
        this.$root.closeLoading()
      })
    },
    jump (item) {
      // this.currentId = item.mid
      this.currentItem = item
      if (!Storage.load('neverPopMessage')) {
        this.isShowDialog = true
        return
      }

      if (item.singleStatus === 6 || item.singleStatus === 7) {
        this.showModal = true
      } else {
        // 直接跳转到个人详情页
        this.toDetail()
      }
    },
    checkKnown () {
      this.notShowAgain = !this.notShowAgain
    },
    confirm () {
      if (this.notShowAgain) {
        Storage.save('neverPopMessage', true)
      } else {
        Storage.save('neverPopMessage', false)
      }
    },
    closed () {
      // 直接跳转到个人详情页
      this.toDetail()
    },
    toDetail () {
      // 设置为已读
      this.$http('/api/member/message/read', {
        targetMemberId: this.currentItem.mid
      })
      this.$router.push({
        path: `/info-${this.currentItem.mid}.html`
      })
    }
  }
}
</script>
<style lang="scss">
.no-message-tips {
  margin-top: 100px;
  color: #9b9b9b;
  font-size: 26px;
  line-height: 38px;
  text-align: center;
}
.no-message-img {
  margin: 60px auto 0;
  display: block;
  width: 166px;
}
</style>
